const Togo = () => import(/* webpackChunkName: "togo setting" */ '@/components/settings/togo')
export default {
    name: 'settings',
    path: 'settings/togo',
    redirect: '/settings/togo/index',
    meta: {label: 'settings'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]},
            component: Togo,
            props: true
        }
    ]
}
